import * as React from "react";
import { css } from "@emotion/css";

interface StepHeaderProps {
  stepHeader: string;
  stepNote: string;
}

const stepHeaderClass = css`
  font-family: "Merriweather", serif;
  font-weight: 700 !important;
  margin-bottom: 10px;
  margin-top: 20px;
  color: #3c8800;
  font-size: 1.2em;
  line-height: 1.2em;
`;

const stepNoteClass = css`
  margin-bottom: 1.5em;
`;

export const StepHeader = ({ stepHeader, stepNote }: StepHeaderProps) => (
  <div>
    <h2 className={stepHeaderClass}>{stepHeader}</h2>
    <p className={stepNoteClass}>{stepNote}</p>
  </div>
);
